export const getRootDomain = () => {
  let domain = window.location.hostname

  if (domain === 'localhost' || domain.includes('127.0.0.1')) {
    return domain
  }

  const splitArray = domain.split('.')
  const arrayLength = splitArray.length

  // handling the case where domain looks like (top-level domain) '.country.code'
  if (arrayLength > 2) {
    domain = splitArray[arrayLength - 2] + '.' + splitArray[arrayLength - 1]
    // check to see if it's using a Country Code Top Level Domain (ccTLD) (i.e. ".me.uk")
    if (splitArray[arrayLength - 2].length == 2 && splitArray[arrayLength - 1].length == 2) {
      // this is using a ccTLD
      domain = splitArray[arrayLength - 3] + '.' + domain
    }
  }

  return domain
}
